export const lang = {
    "loading": {
        "a1": "載入中...",
        "a2": "沒有更多了",
         // new1211
        "a3":"订阅中...",
        "a4":"缴纳中...",
        "a5":"提交中...",
        "a6":"赎回中...",
    },
    "tabbar": {
        "a1": '首頁',
        "a2": '持倉',
        "a3": '行情',
        "a4": '資產',
        "a5": '我的',
    },
    "basic": {
        "a1": "語言切換",
        "a2": "確認",
        "a3": "取消"
    },
    "notifyPopup": {
        "a3": "確定"
    },
    "gywm": {
        "a1": "關於我們",
        "a2": "公司簡介",
        "a3": "隱私權聲明",
        "a4": "服務/使用條款"
    },
    "yssm": {
        "a1": "1. 目的與適用範圍",
        "a2": "本政策旨在保障使用者（個人或法人）在使用本平台過程中其個人資料（{value}）的隱私與安全。",
        "a3": "本政策適用於所有透過本平台或其關聯網站／系統提交或處理的個人資料 — 包括開戶、交易、客服、後台管理等環節。",
        "a4": "2. 資料收集與處理類別",
        "a5": "可能收集和處理的資訊包括，但不限於：",
        "a6": "身分識別資訊：",
        "a7": "姓名、身分證／護照號碼或其他政府核發身分證件資料、出生日期、稅號（若適用）等。",
        "a8": "聯絡方式：",
        "a9": "地址、電子郵件、電話號碼等。",
        "a10": "帳戶與金融資訊：",
        "a11": "銀行帳戶或支付帳戶資訊、財務狀況、交易記錄、資金來源／用途、資產／負債狀況等。",
        "a13": "使用與存取資料：",
        "a14": "IP 位址、裝置資訊、瀏覽器類型、登入資訊、cookie／追蹤識別碼、交易行為、偏好與習慣資料。 ",
        "a15": "其他自願提供的資訊：",
        "a16": "如風險揭露資料、合規文件、驗證文件、通訊記錄等。",
        "a17": "3. 資料處理目的與法律基礎",
        "a18": "收集與處理上述資料的目的可能包括：",
        "a19": "為使用者提供交易服務、帳戶管理與客戶支援；",
        "a20": "遵守適用法律法規（包括反洗錢、身分驗證、稅務合規、證券監管等要求）；",
        "a21": "防止詐欺、洗錢、濫用平台或系統安全的情況；",
        "a22": "改善與維護系統／服務安全與穩定性；",
        "a23": "若使用者同意，也可能用於行銷、新聞／資訊通知、產品或服務推廣 — 但須事先獲得明確同意。",
        "a24": "法律基礎可能包括使用者同意（consentimiento）、合約履行必要性（prestación del servicio）、法律/監管義務（obligación legal）等。",
        "a25": "4. 第三方處理與國際資料轉移",
        "a26": "若必須將資料傳遞給第三方（例如支付處理器、身份驗證服務商、雲端儲存供應商等），平台應確保對方僅用於合約指定用途，並簽訂資料處理協議。",
        "a27": "若資料需要轉移到阿根廷境外，應採取適當的技術、組織和合約保障措施，確保接收地的資料保護水準。",
        "a28": "5. 資料保存與保留期限",
        "a29": "个人資料僅在實現相關目的所必需的期間保存，或出於遵守法律／監管要求、解決糾紛、履行合約義務所需期間。",
        "a30": "使用資料（如行為日誌、cookie 資訊等）可用於內部分析、安全監控，但保留期限應合理且符合隱私法規。",
        "a31": "6. 使用者權利",
        "a32": "使用者作為資料主體，擁有下列權利（依據阿根廷 Ley 25.326 “個人資料保護法”）：",
        "a33": "存取其個人資料（solicitar acceso）",
        "a34": "更正／補充不完整或不正確資料（rectificación）",
        "a35": "請求刪除其資料（cuando no exista base legal para處理）",
        "a36": "在法律允許範圍內反對處理（oponerse al tratamiento）",
        "a37": "若適用，可請求限制處理、資料可攜帶（data portability）等",
        "a38": "平台應提供明確管道（電子郵件、表單或書面申請）以便使用者行使這些權利，也應告知使用者負責資料處理的聯絡人/部門。",
        "a39": "7. 安全措施",
        "a40": "平台應實施適當的技術（加密、存取控制、日誌監控等）和組織措施，防止個人資料遭受未經授權存取、洩露、濫用、修改或銷毀。 ",
        "a41": "儘管採取了合理安全措施，但因互聯網固有風險，平台不能保證絕對安全。用戶理解並接受這一點。",
        "a42": "8. 政策更新與通知",
        "a43": "本隱私權政策可能不時更新。任何重大變更應透過平台公告、電子郵件或其他適當方式通知使用者。",
        "a44": "更新後的政策自公佈之日起生效，繼續使用服務則視為接受新政策。",
        "a45": "9. 適用法律與監管機構",
        "a46": "本政策受阿根廷法律管轄。",
        "a47": "監管機構為 Agencia de Acceso a la Información Pública (AAIP) 或其他適用機構，使用者可向其投訴資料保護相關問題。"
    },
    "fwtk": {
        "a1": "1. 接受條款",
        "a2": "使用者在造訪或使用本平台、建立帳戶或執行交易前，必須閱讀、瞭解並完全接受本條款。",
        "a3": "若使用者不同意本條款，則不得使用平台服務。",
        "a4": "2. 平台權利與變更條款",
        "a5": "平台保留隨時修改、暫停或終止服務、功能、內容或存取權限的權利，恕不另行通知。",
        "a6": "本條款的修改也將公佈，並自發佈時起生效。",
        "a7": "3. 合法使用與禁止行為 ",
        "a8": "使用者承諾依據適用阿根廷法律、誠信原則及公共秩序使用平台。禁止以下行為（包括但不限於）：",
        "a9": "用於任何非法目的或損害第三人權利的用途；",
        "a10": "幹擾或破壞平台正常功能、進行過度要求、發送垃圾訊息 (spam)、使用自動化腳本、機器人 (bots) 或資料抓取 / 爬蟲 (scrapers)；",
        "a11": "未經授權存取、試圖取得或揭露其他使用者/第三方帳戶或敏感資訊；",
        "a12": "上傳或傳播病毒、惡意軟體、間諜軟體或其他有害程式碼；",
        "a13": "偽造身分、冒充他人或使用虛假資料開立帳戶；",
        "a14": "未經允許轉售、轉讓帳戶或共享帳戶存取權限；",
        "a15": "利用本服務進行未經授權的廣告、行銷、競價、出售產品或服務 (除非經平台明確允許)；",
        "a16": "其他違反本條款、法律法規或平台政策的行為。",
        "a17": "若使用者違反上述規定，平台可中止或終止其帳戶，並保留採取法律行動、追究責任、索賠損失的權利。",
        "a18": "4. 責任聲明與風險告知 ",
        "a19": "平台提供的資訊（例如證券／股票報價、市場分析、新聞、研究報告等）僅供參考，不構成對使用者的投資建議、法律建議或稅務建議。",
        "a20": "使用者瞭解並承擔透過本平台進行證券交易或其他金融活動所產生的全部風險。",
        "a21": "平台對因使用 (或無法使用) 服務而導致的任何直接、間接、偶然、特殊或結果性損失 (包括但不限於盈利損失、數據丟失、系統故障等) 不承擔責任。",
        "a22": "5. 合規與反洗錢／身分驗證 (KYC/AML) ",
        "a23": "使用者開戶或進行交易時，可能需要提供身分證明 (護照、身分證等)、地址證明 (水電費帳單等)、資金來源證明 (銀行對帳單、薪資等)、以及其他反洗錢／合規所需文件／資訊。 ",
        "a24": "平台有權基於合規要求拒絕開戶或暫停交易，並不需提供使用者理由。",
        "a25": "6. 隱私權政策整合與資料使用 ",
        "a26": "使用者同意平台依本隱私權聲明收集、處理、儲存其個人資料。",
        "a27": "隱私權政策與本服務條款共同構成雙方協議 (Agreement)。",
        "a28": "7. 適用法律與爭議解決",
        "a29": "本條款受阿根廷法律管轄。若發生爭議，應提交布宜諾斯艾利斯 (或平台所在地) 普通法院 (ordinary courts) 解決。",
        "a30": "8. 聯絡方式 ",
        "a31": "使用者諮詢隱私、資料保護、條款內容、帳戶交易等問題可聯絡{value}回饋。"
    },
    "addDebitCard": {
        "a1": "添加銀行卡",
        "a2": "姓名",
        "a3": "請輸入姓名",
        "a4": "銀行名稱",
        "a5": "請輸入銀行名稱",
        "a6": "請輸入22位{value}",
        "a7": "賬戶類型",
        "a8": "請輸入賬戶類型",
        "a9": "提交",
        // 
        "c1": "绑定成功",
        "c2":"必须是22位纯数字"
    },
    "asset": {
        "a1": "總資產",
        "a2": "市值",
        "a3": "可用餘額",
        "a4": "佔用金額",
        "a5": "總收益",
        "a6": "充值",
        "a7": "提現",
        "a8": "資產轉換",
        "a9": "資金記錄",
        "a10": "資金密碼",
        "a11": "申请贷款",
        "a12": "充值方式",
        "a13": "提现方式",
        // new
        "c1": "实名提示",
        "c2": "立即认证",
        "c3": "取消",
        "c4": "提现需实名认证，是否前往认证？",
        "c5": "查看实名",
        "c6": "实名认证审核中，请通过后再提现！"
    },
    "assetConversion": {
        "a1": "資產轉換",
        "a2": "資金記錄",
        "a3": "從",
        "a4": "可用餘額",
        "a5": "请输入申請金額",
        "a6": "請選擇需要轉換幣種",
        "a7": "到",
        "a8": "當前餘額:",
        "a9": "到賬金額",
        "a10": "轉換金額以實際到賬為準",
        "a11": "立即提交"
    },
    "dayTrading": {
        "a1": "AI交易",
        "a2": "訂單提交",
        "a3": "已申請",
        "a4": "交易中",
        "a5": "交易明細",
        "a6": "參與時間段:",
        "a7": "請輸入您的參與金額(最低{value})",
        "a8": "提交",
        "a9": "訂單編號",
        "a10": "訂單狀態",
        "a11": "待審核",
        "a12": "訂單金額",
        "a13": "已駁回",
        "a14": "訂單編號",
        "a15": "訂單狀態",
        "a16": "已平倉",
        "a17": "交易類型",
        "a18": "買漲",
        "a19": "平倉時間",
        "a20": "交易數量",
        "a21": "買入價格",
        "a22": "買入總價",
        "a23": "手續費",
        "a24": "賣出價格",
        "a25": "賣出總價",
        "a26": "盈利金額",
        "a27": "確認",
        "a28": "取消",
        "a29": "产品介绍",
        "a30": "基于阿根廷交易所全股指数，运用人工智能模型实现多元化的市场配置，同时保持稳定的风险控制并实现持续增长。",
        "a31": "该基金专注于美国市值最大、流动性最强的30只股票，采用等权重策略分散投资风险。Broking AI Quant NGX全市场基金紧密追踪NGX全股指数（ASI），因此适合长期稳定的投资组合配置。",
        "a32": "五天投资，预期日收益率1.5%至3%，平均投资额400万比索可获利9万比索。美国中小市值成长基金旨在投资以增长为导向的中小型企业，提供灵活的回报。",
        "a33": "重点关注国有企业和领先的油气公司，将政策支持与能源行业的稳定回报相结合。",
        "a34": "预计收益",
        "a39": "投資策略",
        "a40": "交易周期",
        "a41": "总利率:{value}",
        "a42": "交易金额",
        "a43": "可用余额：{value}",
        "a44": "最低限额{value}",
        "a45": "余额不足",
        // new
        "c1": "交易金额不能为空",
        // new1206
        "a35": "基于{value}万比索的投资，预计在1至3个交易日内实现每个交易日0.5%至1%的回报，平均每个交易日盈利约为{value2}比索",
        "a36": "基于{value}万比索的投资，预计在1至3个交易日内实现每个交易日1%至1.5%的回报，平均每个交易日盈利约为{value2}万比索",
        "a37": "投资 {value} 万比索，为期5个交易日，预期收益率为每个交易日 3% 至 5%，平均每个交易日利润为 {value2}万比索。",
        "a38": "投资 {value} 万比索，为期7个交易日，预期收益率为每个交易日 3% 至 5%，平均每个交易日利润为 {value2} 万比索。",
        "b1":"{value}天"
    },
    "etf": {
        "a1": "產品贖買",
        "a2": "歷史訂單",
        "a3": "訂單編號",
        "a4": "產品",
        "a5": "周期(天)",
        "a6": "購買時間",
        "a7": "到期時間",
        "a8": "投資金額",
        "a9": "總獲利預期",
        "a10": "持有天數",
        "a11": "釋放金額",
        "a12": "狀態",
        "a13": "已贖回",
        // 
        "c1": "待确认",
        "c2": "交易中",
        "c3": "交易密碼"
    },
    "fundAccountManage": {
        "a1": "財務帳戶管理",
        "a2": "添加銀行卡",
        // newText
        "a3": "銀行卡管理",
        "a4": "地址綁定",
        "a5": "地址類型",
        "a6": "地址",
        "a7": "刪除確認",
        "a8": "確認",
        "a9": "取消",
        "a10": "是否確認刪除此卡？",
        "a11": "ERC地址不能為空",
        "a12": "TRC地址不能為空",
        "a13": "已綁定地址如需更改請聯絡客服",
        "a14": "ERC20地址",
        "a15": "TRC20地址",
    },
    "fundingRecords": {
        "a1": "資金記錄",
        "a2": "購買明細",
        "a3": "存入資金",
        "a4": "提現",
        "a5": "轉換",
        "a6": "已到賬",
        "a7": "申請金額",
        "a8": "實際到帳金額",
        "a9": "金額",
        "a10": "時間",
        // newText
        "a11": "收入",
        "a12": "支出",
        "a13": "充值金額",
        "a14": "未完成",
        "a15": "已完成",
        "a16": "已取消",
        "a17": "待審核",
        "a18": "已到賬",
        "a19": "審核未通過",
        "a20": "提現退款",
    },
    "fundPassword": {
        "a1": "資金密碼",
        "a2": "原密碼",
        "a3": "請輸入原密碼",
        "a4": "新密碼",
        "a5": "請輸入新密碼",
        "a6": "確認密碼",
        "a7": "請輸入確認密碼",
        "a8": "立即提交",
        // newText
        "a9": "請輸入6位純數字密碼",
        "a10": "必須是 6 位數字",
        "a11": "密碼",
        "a12": "請輸入確認密碼",
        "a13":"两次密码不一致"
    },
    "index": {
        "a1": "大宗訂單",
        "a2": "日內交易",
        "a3": "實名認證",
        "a4": "線上客服",
        "a5": "全球指數",
        "a6": "更多",
        "a7": "熱門股票",
        "a8": "自選",
        "a9": "阿根廷",
        "a10": "美股",
        "a11": "股票/代碼",
        "a12": "最新價格({value})",
        "a13": "漲跌幅",
        // newText
        "a14": "智能交易系統",
        "a15": "基於深度學習（Deep Learning）演算法，回測過去10年海量行情數據。",
        "a16": "快速、安全、流暢。重新定義大宗交易。",
        "a17": "大宗折扣",
        "a18": "AI交易",
        "a19": "關於我們",
        "a20": "常見問題",
        "a21": "暫無數據",
        "a22": "完成 KYC 認證，領取體驗金",
        "a23": "實名認證",
        "a24": "恭喜您通过KYC认证,系统已发放体验金券到您的帐户",
        "a25": "立即开启投资",
        "a26": "自動 AI 智投中",
        "a27": "查看收益",
        "a28": "最新價格",
        "a29": "持仓中",
        "a30": "已平仓",
    },
    "ipo": {
        "a1": "股票認購",
        "a2": "已認購",
        "a3": "交易中",
        "a4": "交易明細",
        "a5": "自動訂閱",
        "a6": "未中籤",
        "a7": "申購數量",
        "a8": "中籤時間",
        "a9": "中籤數量",
        "a10": "預計盈利",
        "a11": "待繳納",
        "a12": "已繳納",
        "a13": "招股價",
        "a14": "市場現價",
        "a15": "已平倉",
        // newText
        "a16": "待中簽",
        "a17": "已中簽",
        "a18": "已駁回",
        "a19": "交易密碼",
        "a20": "产品详情",
        "a21": "发行数量",
        "a22": "发行价格",
        "a23": "股票代码",
        "a24": "汇率",
        "a25": "申购时间",
        "a26": "立即申购",
        "a27": "订单号",
        "a28": "认购时间",
        "a29": "等待缴费",
        "a30": "中签价格",
        "a31": "中签股数",
        "a32": "中签总价",
        "a33": "总计收益",
        "a34": "缴费日期",
        "a35": "发布时间",
        "a36": "驳回原因",
        ///
        "a37": "待審核",
        "a38": "待繳費",
        "a39": "等待上市",
        "a40": "已平倉",
        "a41": "已駁回"
    },
    "login": {
        "a1": "請輸入手機號",
        "a2": "請輸入密碼",
        "a3": "線上客服",
        "a4": "忘記密碼?",
        "a5": "安全登入",
        "a6": "沒有帳號？",
        "a7": "去註冊",
        // newText
        "a8": "登入",
        "a9": "歡迎回來，請登入您的帳戶",
        "a10": "手機號格式不正確",
        "a11": "登入成功",
    },
    "register": {
        "a1": "請再次輸入密碼",
        "a2": "邀請碼(必填)",
        "a3": "已有帳號？",
        "a4": "去登入",
        "a5": "安全註冊",
        // newText
        "a6": "註冊",
        "a7": "註冊新賬號",
        "a8": "請輸入手機號",
        "a9": "手機號格式不正確",
        "a10": "請輸入密碼",
        "a11": "至少 6 位且字母和數字組合",
        "a12": "請輸入確認密碼",
        "a13": "兩次輸入的密碼不一致",
        "a14": "請輸入邀請碼",
    },
    "mail": {
        "a1": "通知",
        "a2": "删除",
        // newText
        "a3": "系統公告",
        "a4": "訂單通知",
        "a5": "訂單號",
        "a6": "審核結果",
        "a7": "體驗金通知",
        "a8": "私信通知",
        "a9": "幣種",
        "a10": "市場價格",
        "a11": "購入價",
        "a12": "到期時間",
        "a13":"透過"
    },
    "market": {
        "a1": "請輸入股票名稱",
        "a2": "搜索",
        "a3": "自選",
        "a4": "阿根廷股",
        "a5": "美股",
        "a6": "資訊",
        "a7": "股票/代碼",
        "a8": "最新價格",
        "a9": "漲跌幅",
        // newText
        "a10": "最新價格",
        // new1210
        "a11":"查看详情",
        "a12":"積極的",
        "a13":"消極的",
        "a14":"中性的"
    },
    "marketDetail": {
        "a1": "行情",
        "a2": "今開",
        "a3": "昨收",
        "a4": "最高",
        "a5": "最低",
        "a6": "買入",
        "a7": "買入總價",
        "a8": "可用資金",
        "a9": "總資金",
        "a10": "槓桿倍數",
        "a11": "買入數量",
        "a12": "請輸入購買數量",
        "a13": "止盈價格",
        "a14": "請輸入止盈價格",
        "a15": "止損價格",
        "a16": "請輸入止損價格",
        "a17": "確認",
        "a18": "時間:",
        "a19": "開盤:",
        "a20": "收盤:",
        "a21": "最低:",
        "a22": "最高:",
        // newText
        "a23": "當前價格",
        "a24": "是否開啟止盈",
        "a25": "是否開啟止損",
        "a26": "您的資金最多只能買",
        "a27": "股",
        "a28": "請輸入買入股數",
        "a29": "請輸入止損價格",
        "a30": "止損價格不能大於當前價格",
        "a31": "請輸入止盈價格",
        "a32": "止盈價格不能小於當前價格",
    },
    "mine": {
        "a1": "已實名",
        "a2": "可用資金",
        "a3": "可用資金",
        "a4": "實名認證",
        "a5": "修改登入密碼",
        "a6": "財務管理",
        "a7": "線上客服",
        "a8": "語言切換",
        "a9": "登出",
        // newText
        "a10": "審核中",
        "a11": "未通過",
        "a12": "未實名",
    },
    "newsDetail": {
        "a1": "資訊"
    },
    "otc": {
        "a1": "訂單提交",
        "a2": "待審核",
        "a3": "交易明細",
        "a4": "已駁回",
        "a5": "市場現價",
        "a6": "折扣價格",
        "a7": "一股收益",
        "a8": "最低買入股數",
        "a9": "請輸入購買數量",
        "a10": "買入總價",
        "a11": "可用餘額",
        "a12": "確認",
        "a13": "待審核",
        "a14": "買入時間",
        "a15": "交易數量",
        "a16": "市場現價",
        "a17": "折扣價格",
        "a18": "申購總資金",
        "a19": "已平倉",
        "a20": "已駁回",
        // newText
        "a21": "大宗折扣",
        "a22": "產品訂閱",
        "a23": "已分配",
        "a24": "交易明細",
        "a25": "已駁回",
        "a26": "訂閱價格",
        "a27": "當前價格",
        "a28": "溢價",
        "a29": "發佈時間",
        "a30": "截止時間",
        "a31": "已訂閱",
        "a32": "立即訂閱",
        "a33": "待付款",
        "a34": "訂單號",
        "a35": "訂閱價格",
        "a36": "分配股數",
        "a37": "訂閱總價",
        "a38": "已繳納",
        "a39": "待繳納",
        "a40": "預計盈利",
        "a41": "訂閱時間",
        "a42": "立即繳納",
        "a43": "持倉中",
        "a44": "開始時間",
        "a45": "到期時間",
        "a46": "贖回",
        "a47": "駁回原因",
        "a48": "訂閱確認",
        "a49": "確認",
        "a50": "取消",
        "a51": "立即訂閱獲得更多收益！您確認訂閱？",
        "a52": "繳納確認",
        "a53": "立即繳納獲得更多收益！您確認立即繳納？",
        "a54": "贖回確認",
        "a55": "您確認立即贖回？",
        "a56": "賣出確認",
        "a57": "繼續持倉將獲得更多收益！您確認立即賣出？",
        // new1206
        "c1": "恭喜您订阅成功",
        "c2": "缴纳截止时间"
    },
    "positionDetails": {
        "a1": "投資詳情",
        "a2": "已平倉",
        "a3": "訂單號",
        "a4": "賣出價格",
        "a5": "賣出時間",
        "a6": "買入時間",
        "a7": "交易類型",
        "a8": "買漲",
        "a9": "平倉數量",
        "a10": "買入價格",
        "a11": "合同金額",
        "a12": "手續費",
        "a13": "平倉手續費",
        "a14": "現價",
        "a15": "實際盈虧",
        "a16": "收益率",
        "a17": "槓桿倍數",
    },
    "realNameAuthentication": {
        "a1": "實名認證",
        "a2": "已通過",
        "a3": "身份證驗證",
        "a4": "上傳人像面",
        "a5": "上傳反面",
        "a6": "真實姓名",
        "a7": "請輸入真實姓名",
        "a8": "身份證號",
        "a9": "請輸入身份證號(8位)",
        "a10": "提交",
        // newText
        "a11": "已實名",
        "a12": "審核中",
        "a13": "未通過審核,請重新提交",
        "a14": "電話",
        "a15": "請輸入電話",
        "a16": "郵箱",
        "a17": "請輸入郵箱(选填)",
        "a18": "請上傳身份證",
        "a19": "請填寫姓名",
        "a20": "請填寫身份證號",
        "a21": "請填電話",
        "a22": "郵箱格式不正確",
        "a23": "身份證是 11 位數字",
        "a24": "電話是 10 位數字",
        // newText2
        "c1": "提示",
        "c2": "确认",
        "c3": "提交成功,请等待审核!",
        // new1208
        "c4": "驳回原因"
    },
    "topUp": {
        "a1": "充值",
        "a2": "複製",
        // newText
        "a3": "儲值金額",
        "a4": "請輸入金額",
        "a5": "最低",
        "a6": "需支付金額",
        "a7": "手續費",
        "a8": "實際金額",
        "a9": "如需其他付款通道，請聯絡客服",
        "a10": "聯絡客服",
        "a11": "通知",
        "a12": "聯絡客服",
        "a13": "取消",
        "a14": "該充值通道維護中請聯絡客服充值或者使用虛擬貨幣充值",
        "a15": "最小充值金額為",
        "a16": "請輸入充值金額",
        "a17": "正在加載支付頁面...",
        "a18": "充值",
        "a19": "如需其他付款通道，請聯絡客服",
        "a20": "說明：該通道僅支援{ value }鏈虛擬幣充值，且最低充值{ value2 }",
        "a22": "複製成功",
    },
    "transaction": {
        "a1": "阿根廷",
        "a2": "美股",
        "a3": "请输入搜索关键词",
        "a4": "搜索",
        "a5": "配售",
        "a6": "ETF 持仓",
        "a7": "進行中",
        "a8": "已結束",
        "a9": "市值{value}",
        "a10": "可用資金{value}",
        "a11": "盈虧{value}",
        "a12": "未中籤",
        "a13": "已平倉",
        "a14": "預計盈利",
        "a15": "申購價格{value}",
        "a16": "申購數量",
        "a17": "分配日期",
        "a18": "中簽",
        "a19": "已認繳{value}",
        "a20": "需認繳{value}",
        "a21": "股票名稱",
        "a22": "現價{value}",
        "a23": "成本{value}",
        "a24": "持有",
        "a25": "市值",
        "a26": "損益",
        "a27": "持倉中",
        "a28": "回報率",
        "a29": "買入時間",
        "a30": "到期時間",
        "a31": "基金名稱",
        "a32": "買入金額",
        "a33": "日收益",
        "a34": "日收益率",
        "a35": "總收益",
        "a36": "總收益率",
        "a37": "交易週期",
        "a38": "股票名稱",
        "a39": "賣出價格{value}",
        "a40": "平倉數量",
        "a41": "盈虧",
        "a42": "損益",
        "a43": "已平倉",
        // newText
        "a44": "AI交易",
        "a45": "大宗折扣",
        "a46": "股票",
        "a47": "持倉中",
        "a48": "訂單號",
        "a49": "訂閱價格",
        "a50": "分配股數",
        "a51": "訂閱總價",
        "a52": "已繳納",
        "a53": "待繳納",
        "a54": "預計盈利",
        "a55": "開始時間",
        "a56": "到期時間",
        "a57": "贖回",
        "a58": "盈收",
        "a59": "賣出",
        "a60": "交易中",
        "a61": "交易週期",
        "a62": "天",
        "a63": "預計盈利",
        "a64": "到期時間",
        "a65": "訂閱時間",
        "a66": "贖回確認",
        "a67": "確認",
        "a68": "取消",
        "a69": "您確認立即贖回？",
        "a70": "賣出確認",
        "a71": "您確認立即賣出？",
        // new1206
        "d1": "平仓",
        "d2":"止盈",
        "d3":"止损"
    },
    "updateLoginPassword": {
        "a1": "修改登入密碼",
        "a2": "原密碼",
        "a3": "請輸入原密碼",
        "a4": "新密碼",
        "a5": "請輸入新密碼",
        "a6": "確認密碼",
        "a7": "請輸入確認密碼",
        "a8": "立即提交",
        // newText
        "a9": "至少 6 位且字母和數字組合",
        "a10": "兩次輸入的密碼不一致",
    },
    "withdrawal": {
        "a1": "提現",
        "a2": "可用資金",
        "a3": "銀行卡",
        "a4": "請選擇銀行卡",
        "a5": "請輸入提現金額",
        "a6": "提交",
        "a7": "請選擇 銀行卡",
        "a8": "去綁定",
        "a9": "確認",
        // newText
        "a10": "實際到賬",
        "a11": "手續費",
        "a12": "安全提示",
        "a13": "確認",
        "a14": "請先設置交易密碼",
        "a15": "提交成功，目前銀行交易比較擁堵，資金將於24H內到賬",
        "a16": "請選擇銀行卡",
        "a17": "請輸入提現金額",
        "a18": "最低提現金額",
        // 
        "c1": "提交成功",
    },
    // 阿根廷语言包缺失
    "notifyPopupOtc": {
        "a1": "大宗折扣訂閱通知",
        "a2": "您有多個大宗折扣產品待訂閱",
        "a3": "您有一個大宗折扣產品待訂閱",
        "a4": "股票名稱:",
        "a5": "訂閱價格:",
        "a6": "市場價:",
        "a7": "幣種:",
        "a8": "截止時間:",
        "a10": "股票類型:",
        "a11": "購買價:",
        "a12": "股數:",
        "a13": "股票交易代碼:",
        "a14": "訂單號:",
        "a15": "繳費時間:",
        "a16": "公司名:",
        "a17": "股票類型:",
        "a18": "金額:",
        "a19": "訂單號:",
        "a20": "審核狀態:",
        "a21": "使用者備註:",
        // new1206,
        "a9": "股票名稱:",
        "d1": "您有多個大宗訂單分配成功",
        "d2": "您有一個大宗訂單分配成功",
        "d3": "大宗訂單通知",
        "d4": "您有多個大宗訂單被驳回",
        "d5": "您有一個大宗訂單被驳回",
        "d6": "大宗訂單驳回通知",
        "d7": "驳回"
    },
    "tyjPopup": {
        "a1": "體驗金",
        "a2": "剩餘領取時間",
        "a3": "體驗金",
        "a4": "確定",
        // newText
        "a5": "恭喜您身份審核通過",
        "a6": "獲得",
        "a7": "體驗金",
        "a8": "活動倒數計時",
        "a9": "立即投資",
    },
    "aiTransactionDetails": {
        "a1": "交易詳情",
        "a2": "日期",
        "a3": "當日盈利",
        "a4": "持股詳情",
        "a5": "買入價格",
        "a6": "賣出價格",
        "a7": "持股數量",
        "a8": "當日收益",
        // 
        "c1": "智能交易中...",
    },
    "aiTransactionRecords": {
        "a1": "AI交易記錄",
        "a2": "交易中",
        "a3": "交易明細",
        "a4": "交易週期",
        "a5": "預計盈利",
        "a6": "到期時間",
        "a7": "訂閱時間",
        "a8": "查看詳情",
        "a9": "天",
        // new
        "c1": "待确认",
        "c2": "交易中",
        "c3": "已平仓",
        "c4": "任务失败"
    },
    "fqa": {
        "a1": "常見問題",
        "a2": "我們Matrix受阿根廷政府邀請，基於全球第二大交易所NASDAQ進行交易，受到美國證券交易委員會（SEC）和金融行業監管局（FINRA）嚴格監管，其投資行為具有高度的權威性和可信度。",
        "a3": "目前屬於初步推廣期，交易不收任何費用，提現收取1-千分之三的手續費。匯率按正常比索互兌美元匯率。",
        "a4": "資金存入沒有任何費用，大額資金需提前報備。都是受政府和銀行正規監管，無任何風險提示。",
        "a5": "市場的行情正常波動，肯定存在對應的收益和風險，但公司均提供AI交易、大宗折扣等穩定收益的操作。",
        "a6": "平台是基於正規阿根廷股票和美股交易行情運行，實時保持一致。",
        "a7": "均受美國證券交易委員會（SEC）和金融行業監管局（FINRA）嚴格監管。提現正常收取手續費！",
        "a8": "客戶支援綁定自己的資訊和銀行卡，以及操作APP內所有相關功能，但如未成功交易或申購，是市場行為，與公司無關，如有糾紛可向Matrix公司客服和正規監管部門申訴。",
        "a9": "客戶需要正常操作手機APP功能和理解股市風險，每個客戶都有獨立KYC認證後方可交易，不可盜用他人身份認證等進行交易操作。",
        "a11": "1.該平台是否合法 & 受監管嗎？",
        "a12": "2.交易費用、佣金、匯率和成本如何計算？",
        "a13": "3.資金存入/提現是否安全？",
        "a14": "4.市場 / 流動性 / 波動性風險高不高？",
        "a15": "5.數據是否準確？",
        "a16": "6.法律稅務責任是否合法？",
        "a17": "7.交易資金是否安全，出現爭議如何申訴？",
        "a18": "8.客戶應如何使用我們產品？"
    },
    // newText
    "loan": {
        "a1": "申請貸款",
        "a2": "手機號",
        "a3": "請輸入手機號",
        "a4": "手機號格式不正確",
        "a5": "姓名",
        "a6": "請輸入姓名",
        "a7": "郵箱",
        "a8": "請輸入郵箱",
        "a9": "金額",
        "a10": "請輸入貸款金額",
        "a11": "您暫無貸款資格，請聯絡客服諮詢",
    },
    "loanRecords": {
        "a1": "貸款記錄",
        "a2": "貸款人",
        "a3": "待審核",
        "a4": "審核通過",
        "a5": "審核拒絕",
    },
    "withdrawalu": {
        "a1": "提現地址",
        "a2": "實際到賬",
        "a3": "手續費",
        "a4": "綁定提示",
        "a5": "確認",
        "a6": "請先綁定TRC提現地址",
        "a7": "安全提示",
        "a8": "請先設置交易密碼",
        "a9": "提現地址不可為空",
        "a10": "請輸入提現金額",
        "a11": "最低提現金額",
        "a12": "請先綁定ERC提現地址",
    },
    "about": {
        "a1": "是一家早期風險投資公司，投資範圍涵蓋從創意階段到 A 輪融資的各個階段。我們團隊由一群前創始人及公司建設者組成，關係緊密，曾與蘋果、聯邦快遞、Oculus 和 Canva 等公司合作。",
        "a2": "我們是逆向投資者，憑藉堅定的信念進行投資，與擁有深厚技術專長和明確未來願景的創始人合作。",
        "a3": "團隊",
        "a4": "我們是一支由前創始人及公司建設者組成的緊密團隊。我們投資項目精挑細選，但樂於投入時間。",
        "a5": "我們穩扎穩打，及早參與，並且經久耐用。",
        "a6": "投資",
        "a7": "Ilya Sukhan",
        "a8": "AI、基礎設施",
        "a9": "August Health、Chameleon、Fivetran、Flock Safety、Mashgin、Parabola、Sieve",
        "a10": "Dana Stalder",
        "a11": "金融科技、B2B",
        "a12": "ApartmentList、Baselane、EarnIn、Flexible Finance、Mudflap、Side、Steadily、Zest AI",
        "a13": "Antonio Rodriguez",
        "a14": "AI、前沿科技",
        "a15": "August Health、Chameleon、Fivetran、Flock Safety、Mashgin、Parabola、Sieve",
        "a16": "Kojo Osei",
        "a17": "AI、基礎設施",
        "a18": "Hookdeck、Ampersand、LM Studio",
        "a19": "項目",
        "a20": "挑戰者、逆向思維者、冒險家和現狀打破者。我們投資組合中的公司由擁有深厚技術專長和對未來獨特願景的創始人創立。",
        "a21": "接觸 了解我們永遠不會太早",
        "a22": "舊金山",
        "a23": "加利福尼亞州舊金山米慎街535號2600室，郵編94105，電話：650-798-1600",
        "a24": "波士頓",
        "a25": "馬薩諸塞州劍橋市主街101號17樓，郵編02142，電話：617-494-1223",
    },
    "AiTrialBonus": {
        "a3": "領取體驗金",
        "a4": "開始 AI 智投",
        "a5": "賺取收益",
        "a6": "體驗金策略",
        "a7": "智投週期",
        "a8": "預計收益率",
        "a9": "體驗金",
        "a10": "提交",
        "a11": "我的收益",
        "a12": "當前投資總收益",
        "a13": "每日收益",
        "a14": "買入",
        "a15": "賣出",
        "a16": "持有數量",
        "a17": "收益",
        "a18": "等待收益中",
        "a19": "活動提醒",
        "a20": "返回",
        "a21": "該活動已結束！",
        // new1208
        "a1": "領取體驗金",
        "a2": "AI 演算法分析 + 專業風險控制，讓每一次投資都透明、安全、可控 — 為你的資產保駕護航",
        "b1": "用 AI · 贏未來財富",
        "b2":"天"
    },
    "notifyPopupKyc": {
        "a1": "恭喜您注册成功,请立即前往实名认证!",
        "a2": "前往认证"
    },
    "store": {
        "a1": "实名提示",
        "a2": "立即认证",
        "a3": "取消",
        "a4": "交易需实名认证，是否前往认证？",
        "a5": "查看认证",
        "a6": "实名认证审核中，暂不可交易！"
    },
    // 1209
    "newRouter":{
        "a1":"请先登录",
        "a2":"登录中...",
        "a3":"注册中..."
    },
    "utils":{
        "a1":"{value}天 {value2}时 {value3}分 {value4}秒"
    },
    "oneStocks":{
        "a1":"最高",
        "a2":"最低",
        "a3":"平均价",
        "a4":"成交量",
        "a5":"昨开",
        "a6":"昨收",
        "a7":"振幅",
        "a8":"高水"
    }
};